<template>
  <div id="deleted-modal" class="delete-modal">
    <modal
      :btn-count="2"
      label-left="취소"
      label-right="확인"
      @click-left="clickLeft"
      @click-right="clickRight"
    >
      <template v-slot:modal-body>
        <div class="deleted">
          <strong>정말로 삭제 하시겠습니까?</strong>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Modal from "@/components/modal/modal.vue";

export default {
  components: {
    Modal,
  },

  data() {
    return {};
  },
  methods: {
    clickLeft() {
      this.$emit("click-left");
    },
    clickRight() {
      this.$emit("click-right");
    },
  },
};
</script>

<style scoped>
.delete-modal ::v-deep .modal-mask {
  background-color: rgba(0, 0, 0, 0.33);
}
.delete-modal ::v-deep .modal-wrapper {
  padding: 60px;
  margin: 0px auto;
  width: 30vw;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}
.delete-modal ::v-deep .modal-container {
  opacity: 1;
  width: 250px;
  height: 104px;
  padding: 50px 50px 40px 50px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.delete-modal ::v-deep .left {
  width: 110px;
  height: 40px;
  color: #fff;
  background: #707070;
  margin-right: auto;
}

.delete-modal ::v-deep .right {
  width: 110px;
  height: 40px;
  color: #5a5a5a;
  background: #fff;
  border: 1px solid #707070;
}
.deleted {
  color: #000;
  font-size: 16px;
  text-align: top;
}
</style>
